import React from "react";
import { formatName } from '../../utils/spaUtils';

const SpaReservationCard = (props) => {
    let { item, daysToCruise } = props;
    //window.moment = moment;
    let appointment = processReservation(item);
    let imageUrl = `${process.env.imageUrl}${item.appointment.SpaId}.jpg`;

    if (props.contentFeedData && !appointment.treatmentName) {
        let contentData = props.contentFeedData.find(
            // eslint-disable-next-line eqeqeq
            (data) => data.productCode == appointment.spaId
        )
        appointment.treatmentName = (contentData) ? contentData.productName || '' : '';
    }

    let row = (
        <li className='spa-res-item' >
            <div data-test-id="reservation-table" className="spa-res-item-wrapper row gotham-xn-medium" key={props.item.appointment.SpaId} value={item.buttonText}>

                <div className="spa-res-item-img col-xs-12 col-md-2 img-responsive-wrapper">
                    <img src={imageUrl} alt='' onError={(e) => { e.target.onerror = null; e.target.src = `/images/global/personalizer/image-not-available-640.jpg` }} />
                </div>

                <div className="spa-res-item-content col-xs-12 col-md-6 col-xs-pad-0 col-md-pad-15">
                    <h3 className="spa-res-item-title font-size-p5" data-test-id="service-name">
                        <button style={daysToCruise <= 3 ? { cursor: 'not-allowed' } : {}} disabled={daysToCruise <= 3} className='button-link gotham-xn-book' onClick={() => props.openDetailsPage(appointment.spaId)}>{appointment.treatmentName}</button>
                    </h3>
                    <div className="row spa-res-item-content-row-2 bottom-spacing-5">
                        <div className="col-xs-6 col-sm-5 col-xs-pad-0 spa-land-datetime">{appointment.time} | {appointment.date}</div>
                        <div className="col-xs-6 col-sm-7 col-xs-pad-0" data-test-id="guest-name">{appointment.fullName}</div>
                    </div>
                    <div className="row spa-res-item-content-row-3">
                        <div className="col-xs-6 col-sm-5 col-xs-pad-0">{`Price:${props.ShipboardCurrencyCode === 'USD' ? '$' : 'AU$'} ${appointment.price}`}</div>
                        <div className="col-xs-6 col-sm-7 col-xs-pad-0 green" data-test-id="paid">{appointment.paymentStatus === 'P' ? 'Paid' : 'Charges will be added to your onboard accounts'}</div>
                    </div>
                </div>

                <div className="spa-res-item-btn col-xs-12 col-md-4 font-size-p1" data-test-id="reservation-confirmed">
                    <div id="spa-landing-confirmation-id"><span className='spa-tick-mark'></span> Reservation Confirmed</div>
                    <button className="gotham-xn-medium spa-landing-cancel-id tertiary-btn red" data-test-id="paid-cancel" onClick={props.handleShowCancelPopup} aria-label={`Cancel - ${appointment.treatmentName} for  ${appointment.fullName} from reservations`}>
                        <svg focusable="false" className="svg-icon svg-icon-close-x reserved-cancel-icon "> <use xlinkHref="#icon-close-x" data-test-id="link-close-arrow" ></use></svg>
                        Cancel
					</button>
                </div>

            </div>
        </li>);
    return (row)
};

const processReservation = (appointment) => {
    let _appointment = {};
    let { PassengerDetail } = appointment;
    let { Name } = PassengerDetail;
    _appointment.spaId = appointment.appointment.SpaId;
    _appointment.fullName = formatName(`${Name.FirstName} ${Name.LastName}`);
    _appointment.time = appointment.appointment.formatedTime;
    _appointment.date = appointment.appointment.formatedDate;
    _appointment.price = appointment.appointment.TreatmentPrice;
    _appointment.paymentStatus = appointment.appointment.PaymentStatus;
    _appointment.treatmentName = appointment.appointment.treatmentName;
    return _appointment;
}


export default SpaReservationCard;
